import { useImpersonation } from "../auth/ImpersonationContext";

function formatCountdown(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

/**
 * §9.1's "impossible-to-miss" impersonation banner — rendered at the top of EVERY route
 * (see `App.tsx`), not just the tenant-detail/impersonation-view page, for as long as
 * `ImpersonationContext` has an active session. Exact wording follows the architecture
 * doc's own example almost verbatim: "You are viewing as [tenant] — this session is logged
 * and expires in [N] minutes."
 */
export function ImpersonationBanner() {
  const { active, remainingMs, end } = useImpersonation();
  if (!active) return null;

  return (
    <div className="impersonation-banner" role="alert">
      <span className="impersonation-banner__label">IMPERSONATING</span>
      <span className="impersonation-banner__text">
        You are viewing as <strong>{active.tenantName}</strong> (
        {active.session.impersonated_user_email}) — this session is logged and expires in{" "}
        <strong>{formatCountdown(remainingMs)}</strong>.
      </span>
      <button
        type="button"
        className="impersonation-banner__end"
        onClick={end}
        title="Clears this session from the browser. It's short-lived and expires on its own — there is no separate revoke action needed."
      >
        End session view
      </button>
    </div>
  );
}
